import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { Events } from '@/store/events/types'
import { RootState } from '../types'

export const state: Events = {
  agents: [],
  currentAgent: { conditions: [], id: '', label: '', window: -1, tags: [] },
  filterAgents: []
}

const namespaced = true

export const events: Module<Events, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
